import * as React from "react";

const AddMoreFields = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
        <g fill="none" fill-rule="evenodd">
            <g fill="#006AE3" fill-rule="nonzero">
                <g>
                    <path d="M10.5 21C4.725 21 0 16.275 0 10.5S4.725 0 10.5 0 21 4.725 21 10.5 16.275 21 10.5 21zm0-19.6c-5.005 0-9.1 4.095-9.1 9.1s4.095 9.1 9.1 9.1 9.1-4.095 9.1-9.1-4.095-9.1-9.1-9.1z" transform="translate(-15.000000, -637.000000) translate(15.000000, 637.000000)"/>
                    <path d="M15.75 11.2H5.25c-.386 0-.7-.314-.7-.7 0-.386.314-.7.7-.7h10.5c.386 0 .7.314.7.7 0 .386-.314.7-.7.7z" transform="translate(-15.000000, -637.000000) translate(15.000000, 637.000000)"/>
                    <path d="M10.5 16.45c-.386 0-.7-.314-.7-.7V5.25c0-.386.314-.7.7-.7.386 0 .7.314.7.7v10.5c0 .386-.314.7-.7.7z" transform="translate(-15.000000, -637.000000) translate(15.000000, 637.000000)"/>
                </g>
            </g>
        </g>
        </svg>
    );
};

export default AddMoreFields;